import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { X } from 'lucide-react';
import { registerDataAreaLaunchModal } from '../utils/platformNavigation';

/**
 * Global host for choosing DataAreaId when a platform has multiple company URLs.
 * Mount once under ShellLayout.
 */
export function PlatformDataAreaLaunchModalHost() {
  const [request, setRequest] = useState(null);

  useEffect(() => registerDataAreaLaunchModal(setRequest), []);

  useEffect(() => {
    if (!request) return undefined;
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    const onKeyDown = (event) => {
      if (event.key === 'Escape') {
        request.onCancel?.();
        setRequest(null);
      }
    };
    document.addEventListener('keydown', onKeyDown);
    return () => {
      document.body.style.overflow = previousOverflow;
      document.removeEventListener('keydown', onKeyDown);
    };
  }, [request]);

  if (!request || typeof document === 'undefined') {
    return null;
  }

  const toolName = String(request.tool?.name || request.tool?.key || 'Platform');
  const options = Array.isArray(request.options) ? request.options : [];

  return createPortal(
    <div
      className="modal-backdrop platform-data-area-modal-backdrop is-open"
      onClick={() => {
        request.onCancel?.();
        setRequest(null);
      }}
    >
      <div
        className="modal-card platform-data-area-modal is-open"
        role="dialog"
        aria-modal="true"
        aria-labelledby="platform-data-area-modal-title"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="platform-data-area-modal-header">
          <div>
            <h3 id="platform-data-area-modal-title">Choose company</h3>
            <p className="hint-text">
              Select which DataAreaId to use when opening <strong>{toolName}</strong>.
            </p>
          </div>
          <button
            type="button"
            className="admin-platform-editor-close"
            aria-label="Close"
            onClick={() => {
              request.onCancel?.();
              setRequest(null);
            }}
          >
            <X size={18} />
          </button>
        </div>

        <div className="platform-data-area-modal-list">
          {options.map((option) => (
            <button
              key={option.dataAreaId}
              type="button"
              className="platform-data-area-option"
              onClick={() => {
                request.onPick?.(option);
                setRequest(null);
              }}
            >
              <strong>{option.dataAreaId}</strong>
              <span className="hint-text">{option.url}</span>
            </button>
          ))}
        </div>

        <div className="platform-data-area-modal-footer">
          <button
            type="button"
            className="ghost-button admin-inline-button"
            onClick={() => {
              request.onCancel?.();
              setRequest(null);
            }}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
}
